module.exports = __webpack_public_path__ + "img/mine.f8177403.svg";